<template>
  <div class="map-control-switch leaflet-bottom">
    <!-- <popover-select
      v-if="objLayersOptions.length !== 0"
      text="对象图层"
      v-model="objLayers"
      :multiple="true"
      :options="objLayersOptions"
      @search="search"
    ></popover-select> -->
    <!-- <el-checkbox-group v-model="objLayers" v-if="isLogin">
      <el-checkbox-button
        v-for="opt in objLayersOptions"
        :label="opt.value"
        :key="opt.value"
        ><i class="el-icon-search" @click.stop.prevent="search(opt.value)"></i>
        {{ opt.text }}</el-checkbox-button
      >
    </el-checkbox-group> -->
    <div class="icon-container" @click="zoomIn">
      <i class="el-icon-zoom-in"></i>
    </div>
    <div class="icon-container" @click="zoomOut">
      <i class="el-icon-zoom-out"></i>
    </div>
    <div class="icon-container" @click="measure">
      <img :src="measureIcon" />
    </div>
    <div class="icon-container" @click="measureClear">
      <img :src="measureClearIcon" />
    </div>
    <popover-select
      text=""
      icon="layer"
      v-model="map"
      :options="[
        { value: 'tiandi', text: '天地图' },
        { value: 'gaode', text: '高德地图' }
      ]"
    ></popover-select>
    <div class="color-simple-img" v-if="showLayers.length > 0" v-drag:bottom>
      <popover-select
        v-if="showLayers.length > 1"
        :text="currentImgText"
        icon="el-icon-arrow-down"
        v-model="currentImg"
        :options="imgOptions"
      ></popover-select>
      <div :style="imgStyle"></div>
    </div>

  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { mapGetters } from 'vuex';

import measureIcon from '@/asset/measure.png';
import measureClearIcon from '@/asset/measure-clear.png';
import {
  getToken,
  safeParse,
  safeStringify,
  safeGetSessionStorage,
  safeSetSessionStorage
} from '@/utils/index';
import PopoverSelect from './popover-select';

const HOST = process.env.VUE_APP_LAYER_HOST;
const HOST2 = process.env.VUE_APP_LAYER_HOST2;
const COMBINED_LAYER = {
  cucaodu: `${HOST2}/geoserver/gwc/service/tms/1.0.0/dx:cover@Dx_EPSG:3857@png/{z}/{x}/{y}.png`,
  dixing: `${HOST2}/geoserver/gwc/service/tms/1.0.0/dx:dem@Dx_EPSG:3857@png/{z}/{x}/{y}.png`,
  country: `${HOST}/geoserver/gwc/service/tms/1.0.0/dx:wind3km@Dx_EPSG:3857@png/{z}/{x}/{y}.png`
};
const TMS_LAYERS = [];
const LAYER_ICON = {
  cucaodu: {
    backgroundImage: `url(${require('@/asset/layer/cover.jpg')})`,
    width: '112px',
    height: '174px'
  },
  dixing: {
    backgroundImage: `url(${require('@/asset/layer/dem.jpg')})`,
    width: '76px',
    height: '430px'
  },
  country: {
    backgroundImage: `url(${require('@/asset/layer/chinawind.png')})`,
    width: '57px',
    height: '230px'
  }
};
const LAYER_TEXT = {
  dixing: '地形图',
  cucaodu: '粗糙度',
  country: '全国风速'
};
const LAYER_PERMISSION = {
  dixing: 'compositeLayer-map',
  cucaodu: 'compositeLayer-roughness'
};
const LAYER_MAX_ZOOM = {
  dixing: 13,
  cucaodu: 13,
  country: 11
};

export default {
  components: {
    PopoverSelect
  },
  props: ['outerLayers'],
  data() {
    return {
      towerVisible: false,
      planeVisible: false,
      objLayers: [],
      combinedLayers: [],
      map: '',
      towers: [],
      planes: [],
      bases: [],
      towerParams: null,
      planeParams: null,
      currentImg: '',
      measureIcon,
      measureClearIcon,
    };
  },
  computed: {
    ...mapGetters(['isLogin']),
    // objLayersOptions() {
    //   return [
    //     { value: 'tower', text: '测风塔', searchable: true }
    //     // { value: 'plane', text: '风电场', searchable: true },
    //     // { value: 'base', text: '基地分布' }
    //   ].filter(opt => this.$hasPermission(LAYER_PERMISSION[opt.value]));
    // },
    combinedLayersOption() {
      return ['country', 'dixing', 'cucaodu']
        .filter(key => this.$hasPermission(LAYER_PERMISSION[key]))
        .map(value => ({ value, text: LAYER_TEXT[value] }));
    },
    innerLayers() {
      const innerLayers = [...this.combinedLayers];
      if (this.objLayers.indexOf('plane') !== -1) {
        innerLayers.push('plane');
      }
      return innerLayers;
    },
    showLayers() {
      if (isEmpty(this.outerLayers)) {
        return this.innerLayers;
      }
      return [...this.innerLayers, ...this.outerLayers.map(l => l.type)];
    },
    imgOptions() {
      let options = this.innerLayers.map(value => ({
        value,
        text: LAYER_TEXT[value]
      }));
      if (!isEmpty(this.outerLayers)) {
        options.push(
          ...this.outerLayers.map(layer => ({
            value: layer.type,
            text: layer.text
          }))
        );
      }
      return options;
    },
    currentSampleLayer() {
      if (!isEmpty(this.outerLayers)) {
        return this.outerLayers.find(l => l.type === this.currentImg);
      }
      return null;
    },
    currentImgText() {
      if (this.currentSampleLayer) {
        return this.currentSampleLayer.text;
      }
      return LAYER_TEXT[this.currentImg || this.innerLayers[0]];
    },
    imgStyle() {
      if (this.currentSampleLayer) {
        return this.currentSampleLayer.sample;
      }
      return LAYER_ICON[this.currentImg];
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.map = safeGetSessionStorage('map') || 'tiandi';
      if (getToken()) {
        this.combinedLayers =
          safeParse(safeGetSessionStorage('combinedLayer')) || [];
        this.objLayers = safeParse(safeGetSessionStorage('objectLayer')) || [];
      }
    });
  },
  watch: {
    map(val) {
      this.switchMap(val);
    },
    // combinedLayers(val) {
    //   this.changeCombinedLayer(val);
    //   this.setCurrentImg();
    // },
    // objLayers(val, pre) {
    //   // 查询弹窗展示的时候不自动触发默认条件的查询
    //   if (this.towerVisible) return;
    //   this.changeObjLayer(val, pre);
    //   this.setCurrentImg();
    // },
    // outerLayers() {
    //   this.setCurrentImg();
    // }
  },
  beforeDestroy() {
    this.towerVisible = false;
  },
  methods: {
    setCurrentImg() {
      const layers = this.showLayers;
      if (!isEmpty(layers)) {
        const target = layers.find(layer => layer === this.currentImg);
        if (!target) {
          this.currentImg = layers[0];
        }
      }
    },
    switchMap(value) {
      safeSetSessionStorage('map', value);
      this.$emit('switchMap', value);
    },
    getLayers() {
      const combinedLayers = this.combinedLayers.map(type => ({
        type,
        url: COMBINED_LAYER[type],
        tms: !TMS_LAYERS.includes(type),
        maxNativeZoom: LAYER_MAX_ZOOM[type]
      }));
      return combinedLayers;
    },
    changeCombinedLayer(types) {
      safeSetSessionStorage('combinedLayer', safeStringify(types));
      this.$emit('switchCombinedLayer', this.getLayers());
    },
    async changeObjLayer(layers, preLayers) {
      safeSetSessionStorage('objectLayer', safeStringify(layers));
      await Promise.all(
        this.objLayers.map(async layer => {
          if (preLayers.indexOf(layer) === -1) {
            if (layer === 'tower') {
              await this.searchTower(this.towerParams);
            } else if (layer === 'plane') {
              await this.searchPlane(this.planeParams);
            } else if (layer === 'base') {
              await this.searchBase();
            }
          }
        })
      );
      this.syncLayer();
    },
    search(value) {
      if (value === 'tower') {
        this.towerVisible = true;
        this.planeVisible = false;
        // 查询时默认选中
        this.objLayers = [value];
        safeSetSessionStorage('objectLayer', safeStringify([value]));
      } else {
        this.towerVisible = false;
        this.planeVisible = true;
      }
    },
    async searchTower(params) {
      // safeSetSessionStorage('towerParams', safeStringify(params));
      const res = await this.$fetch({
        url: '/windfarm/windfarm/getTowerBySearch',
        params,
        showError: true,
        showLoading: true
      });
      this.towerVisible = false;
      const towers = (res.data.towerList || []).map(tower => ({
        lat: tower.lat,
        lng: tower.lon,
        data: tower
      }));
      this.towers = towers;
      this.syncLayer();
    },
    async searchPlane(params) {
      // safeSetSessionStorage('planeParams', safeStringify(params));
      const res = await this.$fetch({
        url: '/windfarm/windfarm/getWindFarmBySearch',
        params,
        showError: true,
        showLoading: true
      });
      this.planeVisible = false;
      const planes = [];
      (res.data.projectList || []).forEach(tower => {
        const lonLat = safeParse(tower.lonLat);
        if (lonLat && !isEmpty(lonLat.coordinates)) {
          planes.push({
            lat: lonLat.coordinates[1],
            lng: lonLat.coordinates[0],
            data: tower
          });
        }
      });
      this.planes = planes;
      this.syncLayer();
    },
    async searchBase() {
      const res = await this.$fetch({
        url: '/windfarm/windfarm/getBaseList',
        showError: true,
        showLoading: true
      });
      const bases = [];
      (res.data.baseList || []).forEach(base => {
        bases.push({
          lat: base.lat,
          lng: base.lon,
          data: base
        });
      });
      this.bases = bases;
      this.syncLayer();
    },
    refresh(type) {
      if (type === 'plane') {
        this.planeParams = null;
        this.searchPlane();
      } else if (type === 'tower') {
        this.towerParams = null;
        this.searchTower();
      }
    },
    syncLayer() {
      const data = {
        towers: [],
        planes: [],
        bases: []
      };
      this.objLayers.forEach(layer => {
        data[`${layer}s`] = this[`${layer}s`];
      });
      this.$emit('switchObjectLayer', data);
    },
    zoomIn() {
      this.$emit('zoomIn');
    },
    zoomOut() {
      this.$emit('zoomOut');
    },
    measure() {
      this.$emit('measure');
    },
    measureClear() {
      this.$emit('measureClear');
    }
  }
};
</script>

<style lang="less" scope>
.map-control-switch {
  background: #fff;
  border-radius: 6px;
  font-size: 12px;
  display: flex;
  overflow: hidden;

  > span {
    // &:first-child {
    .el-link {
      border: 0;
    }
    // }
  }

  .el-link {
    padding: 7px 10px;
    border-left: 1px solid #ccc;

    &:hover:after {
      border: 0;
    }

    &:hover {
      .el-link--inner {
        color: @blue;
      }
    }

    .el-link--inner {
      font-size: 12px;
      color: #000;
    }
  }

  .color-simple-img {
    position: fixed;
    bottom: 30px;
    left: 4px;
    background-color: #c8e0f5;
    border-radius: 10px;

    .el-link {
      width: 100%;
      box-sizing: border-box;
      .el-link--inner {
        color: #3e3e3e;
      }
    }
  }

  > .el-checkbox-group {
    &:first-child {
      .el-checkbox-button__inner {
        border-radius: 10px;
      }
    }

    .el-checkbox-button {
      &.is-checked {
        .el-checkbox-button__inner {
          background: #d9e6f3;
          color: @blue;
        }
      }
      .el-checkbox-button__inner {
        background-color: #c8e0f5;
        border: 0;
        // border-left: 1px solid #e3e3e3;
      }
    }

    // .el-checkbox-button__inner {
    //   color: #ccc;

    //   &:hover {
    //     color: #fff;
    //   }
    // }
  }
  .icon-container {
    padding: 8px;
    i {
      display: inline-block;
      width: 16px;
      height: 16px;
      font-size: 16px;
    }
    img {
      display: inline-block;
      width: 16px;
      height: 16px;
    }
    &:hover {
      background: linear-gradient(180deg, #3cd4e2, #738de1);
      i {
        color: #fff;
      }
    }
  }
}
</style>
